/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useCallback, useContext } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { useLoadMoreFieldsHandler } from '../../hooks/useLoadMoreFieldsHandler';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { Text } from 'foundations-components/components/Text';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EditorFieldOptionBase from './EditorFieldOptionBase';
import { isEventBasedFilterFamily } from '../../strategy/eventBasedFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorFieldLoadMoreOption = props => {
  const {
    filterFamily,
    searchString,
    onLoadMore,
    isLoadingMore
  } = props;
  const loadMoreFields = useLoadMoreFieldsHandler();
  const {
    data,
    conditionToRefineKeyPath
  } = useContext(SegmentationFiltersInstanceContext);
  const isRefiningEventBasedFilterFamily = conditionToRefineKeyPath && isEventBasedFilterFamily(filterFamily);
  const hasMore = data.getIn(['fetcherStatuses', filterFamily, 'hasMore']);
  const offset = data.getIn(['fetcherStatuses', filterFamily, 'offset']);
  const onClick = useCallback(() => {
    onLoadMore(true);
    loadMoreFields(filterFamily, offset, searchString);
  }, [offset, searchString, filterFamily, loadMoreFields, onLoadMore]);
  if (isLoadingMore) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 40,
      size: "small"
    });
  }
  if (hasMore && !isRefiningEventBasedFilterFamily) {
    return /*#__PURE__*/_jsxs(EditorFieldOptionBase, {
      onClick: onClick,
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        color: "text-core-disabled",
        paddingInlineEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.fieldSelectFlow.moreFields"
        })
      }), /*#__PURE__*/_jsx(Link, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.fieldSelectFlow.loadMore"
        })
      })]
    });
  }
  return null;
};
export default EditorFieldLoadMoreOption;